/*
 * Copyright (c) 2022. Haodong JU
 */

import hillo from 'hillo'

export async function getBonTemplateList () {
  return (await hillo.get('BonTemplate.php?op=getClassList')).content
}

export async function getBonTemplateClassList (name) {
  return (await hillo.get('BonTemplate.php?', {
    op: 'getList',
    class: name
  })).content
}

export async function updateBonTemplate (id, sort, content, remark) {
  return await hillo.post('BonTemplate.php?op=update', {
    id,
    sort,
    content,
    remark
  })
}

export async function insertBonTemplate (className) {
  return await hillo.get('BonTemplate.php?op=addCurrentTwig', {
    class: className
  })
}

export async function deleteBonTemplate (id) {
  return await hillo.post('BonTemplate.php?op=delete', {
    id
  })
}

export async function previewBonTemplate (className, template) {
  return (await hillo.post('BonTemplate.php?op=renderWithData', {
    className,
    template
  },
  { silent: true })).content?.rendered
}
